module.exports = __webpack_public_path__ + "img/SeidViroj-Abdurehman.082ab500.jpg";